import { Svg } from "../../../utils/svgIcon";

import backArrowSvg from "./sidebar-back-arrow.svg";

export interface SidebarBackArrowProps {
    className?: string;
}

export function SidebarBackArrow({ className }: SidebarBackArrowProps) {
    return <Svg src={backArrowSvg} className={className} />;
}
